<template>
  <div class="pa-2 bg-grey-lighten-4 rounded-lg">
    <v-container class="pa-0 pb-2">
      <v-row>
        <v-col class="text-primary"> Assigned To </v-col>
      </v-row>
      <v-row v-if="!isValid">
        <v-col>
          <v-input :error-messages="errorMessages" :error="!isValid" :model-value="props.modelValue"></v-input>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-for="(assignedTo, ix) in props.modelValue" :key="ix" class="pa-0 pb-2">
      <v-row>
        <v-col cols="12">
          <component
            :is="props.component"
            v-tooltip:top="getTooltipDisplayValue(assignedTo)"
            :label="props.label"
            v-bind="getComponentProps(assignedTo)"
            @update:model-value="updateAssignedTo(ix, $event)" />
          <v-btn-lh v-if="!props.disabled" variant="outlined" class="mt-2" color="error" @click="removeAssignedTo(ix)"
            >Remove {{ assignedTo }}</v-btn-lh
          >
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!props.disabled">
      <v-row>
        <v-col>
          <v-btn-lh variant="outlined" color="primary" @click="addAssignedTo"> Add Another User </v-btn-lh>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { watch, ref } from "vue";
import { useFieldTooltip } from "@/composables/useFieldTooltip";

const { getTooltipDisplayValue } = useFieldTooltip();

const props = defineProps({
  remoteSearch: {
    type: Function,
    default: () => ({}),
  },
  label: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    default: () => [],
  },
  component: {
    type: [String, Object],
    required: true,
  },
  modelValue: {
    type: Array,
    required: true,
  },
  rules: {
    type: Array,
    default: () => [],
  },
  childRules: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const isValid = ref(true);
const errorMessages = ref([]);

const validate = () => {
  errorMessages.value = [];
  for (const rule of props.rules) {
    const result = rule(props.modelValue);
    if (result !== true) {
      errorMessages.value.push(result);
      isValid.value = false;
      return false;
    }
  }
  isValid.value = true;
  return true;
};

watch(() => props.modelValue, validate, { deep: true });
watch(() => props.rules, validate, { immediate: true });

defineExpose({
  validate,
  isValid,
  errorMessages,
});

const updateAssignedTo = (ix, value) => {
  const assignedTos = [...props.modelValue];
  assignedTos[ix] = value;
  emit("update:modelValue", assignedTos);
};

const removeAssignedTo = (ix) => {
  const assignedTos = [...props.modelValue];
  assignedTos.splice(ix, 1);
  emit("update:modelValue", assignedTos);
};

const addAssignedTo = () => {
  const assignedTos = [...props.modelValue];
  assignedTos.push("");
  emit("update:modelValue", assignedTos);
};

const getComponentProps = (assignedTo) => {
  const baseProps = {
    "model-value": assignedTo,
    rules: props.childRules,
    disabled: props.disabled,
  };

  if (props.items && props.items.length > 0) {
    return {
      ...baseProps,
      items: props.items,
    };
  }

  return {
    ...baseProps,
    "remote-search": props.remoteSearch,
  };
};
</script>
